import React, { useState, useEffect, useMemo } from "react";
import Menu from "react-burger-menu/lib/menus/slide";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as MetricActions from "../actions/Actions.js";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import produce from "immer";
import Helper from "../functions/Helper.js";
import Modal from "react-bootstrap/Modal";
import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import NotificationsPopup from "../components/NotificationsPopup.js";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";

var styles = {
  bmCrossButton: {
    height: "30px",
    width: "30px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMenu: {
    background: "#fff",
    padding: "1.5em 1.5em 0",
  },
  bmMorphShape: {
    fill: "#fff",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "block",
    color: "#333",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <i
    style={{ fontSize: 20, cursor: "pointer", marginLeft: 10, padding: 5 }}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    ref={ref}
    className="far fa-user-circle"
  />
));

const renderOption = (props) => {
  let option = props.data;
  return (
    <div
      onClick={() => props.setValue(props.data)}
      style={{
        fontSize: 16,
        fontWeight: 400,
        color: "#555",
        padding: "15px 20px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        userSelect: "none",
        borderBottom: "1px solid #ededed",
      }}
    >
      <picture>
        <source
          type="image/webp"
          data-srcset={Helper.create_source_set(
            { master: option.master, thumbnails: "1" },
            143,
            "webp"
          )}
          sizes="143px"
        />
        <source
          type="image/png"
          data-srcset={Helper.create_source_set(
            { master: option.master, thumbnails: "1" },
            143
          )}
        />
        <img
          alt=""
          width="65"
          style={{
            marginLeft: -5,
            marginRight: 15,
            transform: option.mirror === "1" ? "scaleX(-1)" : "",
          }}
          className="lazyload"
          data-src={Helper.add_options_img(option.master, 143)}
        />
      </picture>
      <span>
        {option.shoe_name}
        {/*props.favs.filter((x)=>x===option.shoe_id).length!==0 &&
            <i style={{marginLeft:10,color:"orange"}} className="fas fa-star"></i>*/}
      </span>
    </div>
  );
};

function Navigation(props) {
  const navigate = useNavigate();
  const location = useLocation();
  let options = produce(props.overview, (draftData) =>
    draftData.sort((a, b) => (a.shoe_name > b.shoe_name ? 1 : -1))
  ).map((x) => ({ ...x, label: x.shoe_name }));

  const closePopup = () => {
    props.actions.last_visit();
    setTimeout(() => setNotifications(false), 100);
  };

  const openPopup = () => {
    if (!showNotifications) {
      Helper.gaEvent("reviews", "notification");
      setNotifications(true);
    }
  };

  const clickNotifications = (value) => {
    if (window.innerWidth > 576) {
      openPopup();
    } else {
      navigate("/shoe-reviews/notifications");
    }
  };
  const [showSearch, setSearch] = useState(false);
  const [showNotifications, setNotifications] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    props.actions.getNotifications({ start: 0, end: 20 });
  }, []);

  let last_visit = new Date(props.last_visit);
  let unread_notifications = useMemo(
    () =>
      props.last_visit === 0 && props.persisted === true
        ? Math.min(5, props.notifications.length)
        : props.notifications.filter((notification) => {
            let notification_date = Helper.getDateFromMysql(notification.date);
            return notification_date > last_visit;
          }).length,
    [props.last_visit, props.notifications]
  );

  return (
    <>
      <div
        style={{ position: "absolute", top: 0, left: 0 }}
        className="d-lg-none"
      >
        <Menu
          customBurgerIcon={false}
          styles={styles}
          isOpen={menuOpen}
          onClose={() => setMenuOpen(false)}
        >
          <div>
            <NavLink
              style={{ color: "#333333" }}
              className={({ isActive }) => {
                return "nav-link " + (isActive ? "activeNav" : "");
              }}
              onClick={() => setMenuOpen(false)}
              to={Helper.getNextUrl(props.filterObject, props.urlMapping)}
              end={true}
            >
              SHOES
            </NavLink>
          </div>
          <div>
            <NavLink
              style={{ color: "#333333" }}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => {
                return "nav-link " + (isActive ? "activeNav" : "");
              }}
              to="/shoe-reviews/quiz/"
            >
              QUIZ
            </NavLink>
          </div>
          <div>
            <NavLink
              style={{ color: "#333333" }}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => {
                return "nav-link " + (isActive ? "activeNav" : "");
              }}
              to="/shoe-reviews/popular/"
            >
              POPULAR
            </NavLink>
          </div>
          <div>
            <NavLink
              style={{ color: "#333333" }}
              className={({ isActive }) => {
                return "nav-link " + (isActive ? "activeNav" : "");
              }}
              to="/shoe-reviews/how-does-it-work/"
            >
              INFO
            </NavLink>
          </div>
          <NavDropdown
            title="MORE"
            id="basic-nav-dropdown"
            style={{ color: "#333!important" }}
          >
            <NavDropdown.Item href="/tools/">Tools</NavDropdown.Item>
            <NavDropdown.Item href="/blog/">Articles</NavDropdown.Item>
            <NavDropdown.Item href="/about/">About</NavDropdown.Item>
          </NavDropdown>
        </Menu>
      </div>

      <div
        css={{
          marginBottom: 20,
          borderBottom: "1px solid #e9ecef",
          "@media (min-width:992px)": { marginBottom: 40 },
        }}
      >
        <Modal
          onHide={() => {
            setSearch(false);
          }}
          show={showSearch}
        >
          <Modal.Body>
            {/*            <Select
              instanceId="mobilesearchbox"
              styles={{
                input: (styles) => ({
                  ...styles,
                  "& input": { transition: "none" },
                }),
                container: (styles) => ({ ...styles, width: "100%" }),
              }}
              components={{ Option: renderOption }}
              onChange={(x) => {
                setSearch(false);
                setTimeout(() => {
                  navigate("/shoe-reviews/" + x.url + "/");
                }, 10);
              }}
              options={options}
              value={null}
              placeholder="Search Shoe"
            /> */}
          </Modal.Body>
        </Modal>
        <div
          style={{ display: "flex", padding: "1rem 0rem" }}
          className="justify-content-between "
        >
          <i
            style={{
              fontSize: 30,
              color: "var(--grey-700)",
              cursor: "pointer",
            }}
            onClick={() => {
              setMenuOpen(true);
            }}
            className="fas fa-bars d-lg-none"
          />
          <a href="/">
            <img
              width="330"
              height="67"
              src={__cdn__ + "/wp-content/uploads/2023/07/logo.svg"}
              className="custom-logo astra-logo-svg"
              alt="thehoopsgeek.com"
            />
          </a>

          <Select
            className="d-none d-lg-block"
            instanceId="desktopsearchbox"
            styles={{
              input: (styles) => ({
                ...styles,
                "& input": { transition: "none" },
              }),
              menu: (styles) => ({ ...styles, zIndex: 2 }),
              container: (styles) => ({
                ...styles,
                flex: 1,
                margin: "0px 24px 0px 40px",
              }),
            }}
            components={{ Option: renderOption }}
            onChange={(x) => {
              setSearch(false);
              setTimeout(() => {
                navigate("/shoe-reviews/" + x.url + "/");
              }, 10);
            }}
            options={options}
            value={null}
            placeholder="Search Shoe"
          />

          <NavLink
            end
            className={({ isActive }) =>
              "d-none d-lg-block nav-link " + (isActive ? "activeNav" : "")
            }
            to={Helper.getNextUrl(props.filterObject, props.urlMapping)}
          >
            SHOES
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              "d-none d-lg-block nav-link " + (isActive ? "activeNav" : "")
            }
            to="/shoe-reviews/quiz/"
          >
            QUIZ
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              "d-none d-lg-block nav-link " + (isActive ? "activeNav" : "")
            }
            to="/shoe-reviews/popular/"
          >
            POPULAR
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              "d-none d-lg-block nav-link " + (isActive ? "activeNav" : "")
            }
            to="/shoe-reviews/how-does-it-work/"
          >
            INFO
          </NavLink>
          <NavDropdown
            className="d-none d-lg-block"
            title="MORE"
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item href="/tools/">Tools</NavDropdown.Item>
            <NavDropdown.Item href="/blog/">Articles</NavDropdown.Item>
            <NavDropdown.Item href="/about/">About</NavDropdown.Item>
          </NavDropdown>

          <div style={{ display: "flex" }}>
            <div
              className="d-lg-none"
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <div style={{ position: "relative", marginLeft: 15 }}>
                <i
                  onClick={() => setSearch(true)}
                  style={{ fontSize: 20 }}
                  className="fas fa-search"
                ></i>
              </div>
            </div>

            <div
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <div style={{ position: "relative", marginLeft: 15 }}>
                <div
                  onClick={() => {
                    navigate("/shoe-reviews/likes/");
                  }}
                >
                  <i style={{ fontSize: 20 }} className="far fa-heart"></i>
                  {props.likes.length > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: -15,
                        left: 10,
                        backgroundColor: "var(--primary-color-600)",
                        height: 22,
                        width: 22,
                        borderRadius: 11,
                        lineHeight: "22px",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: 12,
                        textAlign: "center",
                      }}
                    >
                      {props.likes.length}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              id="notification_bell"
              onClick={() => {
                clickNotifications(!showNotifications);
              }}
              style={{
                display: "flex",
                cursor: "pointer",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <div style={{ position: "relative", marginLeft: 15 }}>
                <i style={{ fontSize: 20 }} className="fas fa-bell"></i>
                {unread_notifications > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: -15,
                      left: 10,
                      backgroundColor: "red",
                      height: 22,
                      width: 22,
                      borderRadius: 11,
                      lineHeight: "22px",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: 12,
                      textAlign: "center",
                    }}
                  >
                    {unread_notifications}
                  </div>
                )}
              </div>
              {showNotifications && (
                <div style={{ position: "relative" }}>
                  <ClickAwayListener onClickAway={() => closePopup()}>
                    <div>
                      <NotificationsPopup
                        lastVisit={last_visit}
                        onHide={() => {
                          closePopup();
                        }}
                        resetCount={props.actions.last_visit}
                        notifications={props.notifications}
                      />
                    </div>
                  </ClickAwayListener>
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Dropdown style={{ marginRight: 0 }}>
                <Dropdown.Toggle as={CustomToggle} />
                <Dropdown.Menu>
                  {props.status === "LOGGED_IN" && (
                    <Dropdown.Item as={Link} to={"/shoe-reviews/account"}>
                      My Account
                    </Dropdown.Item>
                  )}

                  {props.status !== "LOGGED_IN" && (
                    <Dropdown.Item
                      as={Link}
                      to={{
                        pathname: "/shoe-reviews/login",
                        state: { nextPath: location.pathname },
                      }}
                    >
                      Login
                    </Dropdown.Item>
                  )}
                  {props.status === "LOGGED_IN" && (
                    <Dropdown.Item
                      onClick={() => {
                        props.actions.logout();
                      }}
                      as={Link}
                      to={"/shoe-reviews/login"}
                    >
                      Logout
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
              {/*}<LinkContainer to={"/shoe-reviews/login"}>
                <div style={{position:"relative",marginLeft:15,}}>
                  <i style={{fontSize:20,}} className="far fa-user-circle"/>
                </div>
            </LinkContainer>*/}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(
  (state) => ({
    ...state.data,
    ...state.persistData,
    persisted: state.hasOwnProperty("_persist"),
  }),
  (dispatch) => ({
    actions: bindActionCreators(MetricActions, dispatch),
  })
)(Navigation);
